import { DadataLib } from '@/libs/dadata/index'
import { $ } from '@/libs/jquery/index'
import { LeadsOrgService } from '@/views/application/leads/shared/dadata/leads_org_service'

const selectors: ISelectors = {
  dadataCompany: '[data-selector="dadataCompany"]',
  dadataInn: '[data-selector="dadataInn"]',
}

export const attachDatataFieldsToLead = (baseSelector: string): void => {
  const base: JQuery = $(baseSelector)
  const checkOrganizationService = new LeadsOrgService({
    innField: base.find(selectors.dadataInn),
    nameField: base.find(selectors.dadataCompany),
  })

  const dadata = new DadataLib({
    searchField: base.find(selectors.dadataCompany),
    successCallback: (suggest: IDadataResponseNode<IParty>) => checkOrganizationService.successCallback(suggest),
  })

  const dadata2 = new DadataLib({
    searchField: base.find(selectors.dadataInn),
    successCallback: (suggest: IDadataResponseNode<IParty>) => checkOrganizationService.successCallback(suggest),
  })
}
